<template>

    <div class="user">
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <el-form-item label="是否开启" prop="status">
          <el-switch v-model="form.status"></el-switch>
        </el-form-item>


        <el-form-item label="是否开启全部" prop="is_all">
          <el-switch v-model="form.is_all"></el-switch>
        </el-form-item>

        <el-form-item label="是否开启热门推荐" prop="is_recommond">
          <el-switch v-model="form.is_recommond"></el-switch>
        </el-form-item>



        <el-form-item label="热门推荐商品"  >
        <el-button size="small" type="primary" @click="addProduct" >新增热门推荐商品</el-button>
        <el-table :data="form.product" border size="mini" style="width: 100%;margin-top: 20px;">

          
          <el-table-column prop="name" label="商品名称" width="250">
              <template v-slot="scope">
                <div class="d-s-c">
                  {{ scope.row.product_name }}
                </div>
              </template>

            </el-table-column>

            <el-table-column prop="sort" label="排序" width="250">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 200px;" v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>

            </el-table-column>
                 

            <el-table-column prop="name" label="选择" width="250">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-button icon="el-icon-plus" @click="changeProduct(scope.$index)">选择商品</el-button>
                </div>
              </template>

            </el-table-column>


         
  

            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delProduct(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>
  
  
      </el-form>


  
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
      </div>
     <!--商品选择-->
      <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeDialogFunc"></Product>

      <!--商品图片组件-->
      <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
    </div>
  </template>
  <script>
  import PorductApi from '@/api/product.js';
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  import Product from '@/components/product/Product';
  export default {
    components: {
      Upload,
      draggable,
      Product
    },
    data() {
      return {
        form: {
          status: false,
          product:[],
          is_all:false,
          is_recommond:false,
        },
        setting: [],
        loading: false,
        isProductUpload:false,
        isproduct:false,
        excludeIds:[],
        islist:false,
        index:0,
      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      addProduct(){
        this.form.product.push({
          "product_id":0,
          'product_name':"",
          "sort":1,
          
        });
    },
    delProduct(idex){
      this.form.product.splice(idex,1)
    },
    /*打开添加*/
    changeProduct(index) {
          this.index = index;
          let arr = [];
          this.form.product.forEach(item => {
            arr.push(item.product_id);
          });
          this.excludeIds = arr;
          this.isproduct = true;
    },
    closeDialogFunc(e) {
      console.log("e,e",e.params)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        self.form.product[self.index].product_id = e.params.product_id
        self.form.product[self.index].product_name = e.params.product_name
      }
    },
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        PorductApi.getSetting(Params, true)
          .then(data => {
            self.loading = false;
            console.log(data)
            if(data.data.vars.values!='[]'){
              self.form = data.data.vars.values;
            }
            if(!self.form.product){
              self.form.product = [];
            }
            
          })
          .catch(error => {});
      },
      /*点击保存*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.loading = true;
        PorductApi.saveSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
  
    }
  };
  </script>
  
  <style>
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  
  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  
  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }
  
  .draggable-list .item:hover .delete-btn {
    display: block;
  }
  
  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }
  
  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }
  
  .draggable-list .img-select i {
    color: #409eff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/product/category/setting/index.vue